import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  searchValue ;
  searchFlage = false;

  constructor() { }

  addSearchVal(search : string) {
    this.searchValue = search;
  }

  getSearchVal(){
    return this.searchValue;
  }

  setSearchFlag(){
    this.searchFlage = true;
  }

  clearSearchFlag(){
    this.searchFlage = false;
  }

  getSearchFlag(){
    return this.searchFlage;
  }


}
